var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstrela(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 122.849,
    height: 116.836,
    viewBox: "0 0 122.849 116.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_304",
    "data-name": "Caminho 304",
    d: "M47.295,165.5,0,165.221l38.562,27.156-15.1,45.053,37.962-28.442L99.387,237.43l-15.1-45.053,38.562-27.156-47.294.28-14.13-44.907Z",
    transform: "translate(0 -120.594)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 1.741,
    x2: 0.001,
    y2: 1.741,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#261b14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#66462a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66462a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_305",
    "data-name": "Caminho 305",
    d: "M352.454,169.942l-3.206-4.441,14.13-44.907v14.835Z",
    transform: "translate(-349.248 -120.594)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.56,
    y1: 6.574,
    x2: -0.558,
    y2: 6.574,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54341a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#895b34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#805938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805938"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_306",
    "data-name": "Caminho 306",
    d: "M12.748,454.266l37.753.6-3.206-4.441L0,450.146Z",
    transform: "translate(0 -450.146)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 33.635,
    x2: 0.003,
    y2: 33.635,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a06f3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#f5dc8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5dc8b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_307",
    "data-name": "Caminho 307",
    d: "M38.562,477.3l5.211-1.665L12.748,454.266,0,450.146Z",
    transform: "translate(0 -450.146)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.047,
    y1: 3.335,
    x2: 0.05,
    y2: 3.335,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf984c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcfffc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_308",
    "data-name": "Caminho 308",
    d: "M193.567,638.386l-5.211,1.665-15.1,45.052,9.912-13.671Z",
    transform: "translate(-173.256 -638.386)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.368,
    y1: 2.66,
    x2: -0.364,
    y2: 2.66,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efd483"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fcfbc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#f1cb75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96721c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_309",
    "data-name": "Caminho 309",
    d: "M211.218,735.761l-28.05,19.86-9.912,13.671,37.962-28.442Z",
    transform: "translate(-173.256 -735.761)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -0.345,
    y1: 2.541,
    x2: -0.343,
    y2: 2.541,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbf8ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#f9f3b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#f6e5a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#efce88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#e8b065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#daa15b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a76c39"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_310",
    "data-name": "Caminho 310",
    d: "M481.919,756.006,453.59,735.761v5.089l37.962,28.442Z",
    transform: "translate(-453.59 -735.761)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -1.088,
    y1: 2.563,
    x2: -1.085,
    y2: 2.563,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faf1c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#be8744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#745631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c48b49"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_311",
    "data-name": "Caminho 311",
    d: "M597.02,672.587l-10.3-33.31,4.834,1.545,15.1,45.052Z",
    transform: "translate(-586.72 -639.277)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1.477,
    y1: 2.765,
    x2: -1.474,
    y2: 2.765,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcf8ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#8e6039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#594228"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_312",
    "data-name": "Caminho 312",
    d: "M586.72,475.758,615.3,454.933l14.813-4.787L591.554,477.3Z",
    transform: "translate(-586.72 -450.146)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -1.476,
    y1: 3.629,
    x2: -1.474,
    y2: 3.629,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b58b54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#debf79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0ae60"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_313",
    "data-name": "Caminho 313",
    d: "M535.206,454.688l3.077-4.262,47.294-.28-14.813,4.787Z",
    transform: "translate(-535.206 -450.146)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -1.434,
    y1: 24.406,
    x2: -1.431,
    y2: 24.406,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6b76a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#fcf9c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffefc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_314",
    "data-name": "Caminho 314",
    d: "M464.642,169.764,453.59,135.429V120.594L467.72,165.5Z",
    transform: "translate(-453.59 -120.594)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -2.349,
    y1: 4.004,
    x2: -2.343,
    y2: 4.004,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74532f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#785630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#846136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#99743f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#b68d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#cca157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "#d0a865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#dbbd8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#eedfc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#fefcfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fcf8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#faefdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f5e0bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#efcc8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eabb64"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_315",
    "data-name": "Caminho 315",
    d: "M142.815,495.768l-10.923-14.6-37.753-.6Z",
    transform: "translate(-94.139 -480.57)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.549,
    cy: 0.754,
    r: 1.186,
    gradientTransform: "matrix(0.312, 0, 0, -1, -0.18, 20.354)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5de9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#f5de9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#f2d793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#ecc47d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#e4ac62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#daa45d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#c18f52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    stopColor: "#986e40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e5934"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_316",
    "data-name": "Caminho 316",
    d: "M372.926,264.656l10.923-34.514v49.111Z",
    transform: "translate(-372.926 -230.142)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.473,
    cy: 0.863,
    r: 0.764,
    gradientTransform: "matrix(4.496, 0, 0, -1, 16.163, 7.68)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1964f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#b38145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#876236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#644a2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#4c3922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#3d2e1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#382b1c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_317",
    "data-name": "Caminho 317",
    d: "M453.59,230.142l11.052,34.335L453.59,279.253Z",
    transform: "translate(-453.59 -230.142)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -0.836,
    y1: 6.885,
    x2: -0.833,
    y2: 6.885,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74532f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#785630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#846136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    stopColor: "#99733f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#b68d4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#daad5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#eabb64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#edc67f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#f4ddb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#f9eeda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#fcf8f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefcfa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_318",
    "data-name": "Caminho 318",
    d: "M464.642,483.689l35.559.245L453.59,498.465Z",
    transform: "translate(-453.59 -483.689)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -1.308,
    y1: 9.922,
    x2: -1.305,
    y2: 9.922,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_319",
    "data-name": "Caminho 319",
    d: "M453.59,500.029,500.2,485.5l-28.583,20.824Z",
    transform: "translate(-453.59 -485.498)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -1.265,
    y1: 3.532,
    x2: -1.263,
    y2: 3.532,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e4629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#6a4d2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#755432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5b259"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_320",
    "data-name": "Caminho 320",
    d: "M453.59,592.8l18.028,6.293,10.3,33.31Z",
    transform: "translate(-453.59 -592.804)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -1.249,
    y1: 2.986,
    x2: -1.246,
    y2: 2.986,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_321",
    "data-name": "Caminho 321",
    d: "M274.5,592.8v19.359l-28.05,19.86Z",
    transform: "translate(-246.454 -592.804)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -0.556,
    y1: 2.988,
    x2: -0.553,
    y2: 2.988,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_322",
    "data-name": "Caminho 322",
    d: "M274.5,592.8l-17.651,6.173-10.4,33.047Z",
    transform: "translate(-246.454 -592.804)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -0.629,
    y1: 3.029,
    x2: -0.625,
    y2: 3.029,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efd483"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fcfbc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#f1cb75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b38019"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_323",
    "data-name": "Caminho 323",
    d: "M94.139,480.57l31.025,21.371,17.651-6.173Z",
    transform: "translate(-94.139 -480.57)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -0.244,
    y1: 3.427,
    x2: -0.241,
    y2: 3.427,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcfffc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf984c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_324",
    "data-name": "Caminho 324",
    d: "M453.59,592.8l28.329,39.6L453.59,612.163Z",
    transform: "translate(-453.59 -592.804)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -1.057,
    y1: 3.178,
    x2: -1.055,
    y2: 3.178,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c48b49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#be8744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#745631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca9350"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_439",
    "data-name": "Grupo 439",
    transform: "translate(-1948.357 272.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_321",
    "data-name": "Grupo 321",
    transform: "translate(1948.357 -272.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_320",
    "data-name": "Grupo 320",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_103",
    "data-name": "Ret\\xE2ngulo 103",
    width: 122.848,
    height: 116.836,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_323",
    "data-name": "Grupo 323",
    transform: "translate(1995.652 -272.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_322",
    "data-name": "Grupo 322",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_104",
    "data-name": "Ret\\xE2ngulo 104",
    width: 51.26,
    height: 29.426,
    transform: "matrix(0.326, -0.946, 0.946, 0.326, -15.191, 44.118)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_325",
    "data-name": "Grupo 325",
    transform: "translate(1948.357 -228.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_324",
    "data-name": "Grupo 324",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_105",
    "data-name": "Ret\\xE2ngulo 105",
    width: 50.501,
    height: 4.721,
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_327",
    "data-name": "Grupo 327",
    transform: "translate(1948.357 -228.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_326",
    "data-name": "Grupo 326",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_106",
    "data-name": "Ret\\xE2ngulo 106",
    width: 48.349,
    height: 51.213,
    transform: "matrix(0.616, -0.788, 0.788, 0.616, -13.175, 16.863)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_329",
    "data-name": "Grupo 329",
    transform: "translate(1971.819 -202.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_328",
    "data-name": "Grupo 328",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_107",
    "data-name": "Ret\\xE2ngulo 107",
    width: 38.735,
    height: 50.893,
    transform: "translate(-18.407 8.978) rotate(-26)",
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_331",
    "data-name": "Grupo 331",
    transform: "translate(1971.819 -189.504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_330",
    "data-name": "Grupo 330",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_108",
    "data-name": "Ret\\xE2ngulo 108",
    width: 50.212,
    height: 50.649,
    transform: "translate(-16.603 19.099) rotate(-49)",
    fill: "url(#linear-gradient-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_333",
    "data-name": "Grupo 333",
    transform: "translate(2009.782 -189.504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_332",
    "data-name": "Grupo 332",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_109",
    "data-name": "Ret\\xE2ngulo 109",
    width: 50.634,
    height: 50.088,
    transform: "matrix(0.766, -0.643, 0.643, 0.766, -16.511, 13.854)",
    fill: "url(#linear-gradient-7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_335",
    "data-name": "Grupo 335",
    transform: "translate(2027.81 -202.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_334",
    "data-name": "Grupo 334",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_110",
    "data-name": "Ret\\xE2ngulo 110",
    width: 45.222,
    height: 48.509,
    transform: "matrix(0.766, -0.643, 0.643, 0.766, -22.944, 19.253)",
    fill: "url(#linear-gradient-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_337",
    "data-name": "Grupo 337",
    transform: "translate(2027.81 -228.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_336",
    "data-name": "Grupo 336",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_111",
    "data-name": "Ret\\xE2ngulo 111",
    width: 51.185,
    height: 46.41,
    transform: "matrix(0.839, -0.545, 0.545, 0.839, -12.404, 8.055)",
    fill: "url(#linear-gradient-9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_339",
    "data-name": "Grupo 339",
    transform: "translate(2020.834 -228.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_338",
    "data-name": "Grupo 338",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_112",
    "data-name": "Ret\\xE2ngulo 112",
    width: 50.508,
    height: 6.542,
    transform: "translate(-0.167 0.006) rotate(-2)",
    fill: "url(#linear-gradient-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_341",
    "data-name": "Grupo 341",
    transform: "translate(2009.782 -272.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_340",
    "data-name": "Grupo 340",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_113",
    "data-name": "Ret\\xE2ngulo 113",
    width: 24.044,
    height: 51.033,
    transform: "translate(-10 2.125) rotate(-12)",
    fill: "url(#linear-gradient-11)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_343",
    "data-name": "Grupo 343",
    transform: "translate(1961.106 -224.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_342",
    "data-name": "Grupo 342",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_114",
    "data-name": "Ret\\xE2ngulo 114",
    width: 48.676,
    height: 15.199,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_345",
    "data-name": "Grupo 345",
    transform: "translate(1998.858 -257.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_344",
    "data-name": "Grupo 344",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_115",
    "data-name": "Ret\\xE2ngulo 115",
    width: 10.923,
    height: 49.111,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_347",
    "data-name": "Grupo 347",
    transform: "translate(2009.782 -257.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_346",
    "data-name": "Grupo 346",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_116",
    "data-name": "Ret\\xE2ngulo 116",
    width: 50.123,
    height: 25.688,
    transform: "matrix(0.309, -0.951, 0.951, 0.309, -14.433, 44.421)",
    fill: "url(#linear-gradient-12)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_349",
    "data-name": "Grupo 349",
    transform: "translate(2009.782 -223.639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_348",
    "data-name": "Grupo 348",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_117",
    "data-name": "Ret\\xE2ngulo 117",
    width: 46.862,
    height: 15.587,
    transform: "translate(-0.258 0.004) rotate(-1)",
    fill: "url(#linear-gradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_351",
    "data-name": "Grupo 351",
    transform: "translate(2009.782 -223.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_350",
    "data-name": "Grupo 350",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_118",
    "data-name": "Ret\\xE2ngulo 118",
    width: 47.995,
    height: 47.359,
    transform: "translate(-10.406 10.049) rotate(-44)",
    fill: "url(#linear-gradient-14)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_353",
    "data-name": "Grupo 353",
    transform: "translate(2009.782 -208.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_352",
    "data-name": "Grupo 352",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_119",
    "data-name": "Ret\\xE2ngulo 119",
    width: 43.221,
    height: 48.148,
    transform: "matrix(0.891, -0.454, 0.454, 0.891, -16.02, 8.163)",
    fill: "url(#linear-gradient-15)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_355",
    "data-name": "Grupo 355",
    transform: "translate(1981.732 -208.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_354",
    "data-name": "Grupo 354",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_120",
    "data-name": "Ret\\xE2ngulo 120",
    width: 44.885,
    height: 48.169,
    transform: "matrix(0.839, -0.545, 0.545, 0.839, -17.914, 11.634)",
    fill: "url(#linear-gradient-16)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_357",
    "data-name": "Grupo 357",
    transform: "translate(1981.732 -208.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_356",
    "data-name": "Grupo 356",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_121",
    "data-name": "Ret\\xE2ngulo 121",
    width: 41.997,
    height: 47.399,
    transform: "matrix(0.906, -0.423, 0.423, 0.906, -15.022, 7.005)",
    fill: "url(#linear-gradient-17)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_359",
    "data-name": "Grupo 359",
    transform: "translate(1961.106 -224.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_358",
    "data-name": "Grupo 358",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_122",
    "data-name": "Ret\\xE2ngulo 122",
    width: 49.86,
    height: 49.186,
    transform: "matrix(0.719, -0.695, 0.695, 0.719, -10.679, 10.313)",
    fill: "url(#linear-gradient-18)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_361",
    "data-name": "Grupo 361",
    transform: "translate(2009.782 -208.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_360",
    "data-name": "Grupo 360",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_123",
    "data-name": "Ret\\xE2ngulo 123",
    width: 48.537,
    height: 44.68,
    transform: "translate(-17.484 29.098) rotate(-59)",
    fill: "url(#linear-gradient-19)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstrela);
export default __webpack_public_path__ + "static/media/estrela.00b619de22362ecb7c739578c6796b04.svg";
export { ForwardRef as ReactComponent };